export default "__VITE_ASSET__12476637__"